import { permissionsForRole } from '@ctcells/core'
import type { UserRole } from '@ctcells/contract'

import type { ScreenAccess } from '../screens/access.ts'

/**
 * 🔸 **데모 권한.** 실세션을 안 태우는 표면(태블릿 라우트 조각)이 화면을 그릴 수 있게 끼우는 값이다.
 *
 * 🔴 **권한표를 여기에 «복사하지» 않는다**(2026-09-21 수정). 종전 이 파일은 `ROLE_PERMISSIONS`
 *    의 사본을 들고 있었고 **그 사본이 낡아 있었다** — `viewer: ['view','monitor']` 로 남아
 *    있었는데, 정본은 2026-09-21 에 `viewer: ['monitor']` 로 바뀌었다(서버가 viewer 의 PII
 *    경로를 403 으로 막는다 · `sessionStore.ts` 머리말의 표). 사본이 셋이었고 둘이 낡았다.
 *    ⇒ **정의처는 `@ctcells/core` 의 `ROLE_PERMISSIONS` 하나다.** 여기서는 그것을 «부른다».
 *
 * 🔴 **화면 컴포넌트의 기본값은 이것이 아니라 `{}` 다.** 권한을 모르면 조작 버튼이 전부
 *    비활성 + 사유가 되는 쪽이 안전한 기본값이고, 프론트가 역할에서 권한을 유도하지 않는다는
 *    규약과도 맞는다. 여기 값은 **서버가 줄 목록의 자리표시자**일 뿐이다.
 *
 * ⚠ **인증 API 는 이미 붙었다**(옛 주석의 「백엔드 라우트 0건」은 2026-09-18 에 사실이 아니게
 *   됐다 — `POST /auth/login`·`/auth/refresh` 실재). 이 파일이 남은 것은 인증이 없어서가
 *   아니라 **태블릿 라우트 조각이 아직 실세션을 안 타기 때문**이다. 그 조각이 컨테이너로
 *   바뀌면(`useScreenAccess`) 이 파일은 지운다.
 */

/**
 * 데모 역할. **이 한 줄만 바꾸면** 역할별 화면(권한 없음 표기 · 마스킹)을 눈으로 확인할 수 있다.
 * 설정으로 빼지 않은 것은 이 파일 자체가 세션이 붙으면 지워질 자리표시자이기 때문이다.
 */
const DEMO_ROLE: UserRole = 'admin'

export const DEMO_ACCESS: ScreenAccess = {
  permissions: permissionsForRole(DEMO_ROLE),
  lockHeld: true,
  controlDisabled: false,
}
